import { render, staticRenderFns } from "./InvoiceStaffCard.vue?vue&type=template&id=66f6fb0e&"
import script from "./InvoiceStaffCard.vue?vue&type=script&lang=js&"
export * from "./InvoiceStaffCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports